
$(document).ready(function(){
  var mainSlider =  $('.owl-carousel');
  var thumbsSlider = $('.owl-thumbs');
  if (mainSlider.length) {
    mainSlider.owlCarousel({
      loop: false,
      items:1,
      nav:false,
      dots: false,
      animateOut: 'animate__fadeOutLeftBig',
      animateIn: 'animate__fadeInLeftBig',
      mouseDrag: true,
      touchDrag: true,
      autoHeight: true,
      responsive : {
        // breakpoint from 1365 up
        1365 : {
          mouseDrag: false,
          touchDrag: false
        }
      }
    });

    if (thumbsSlider.length) {
      thumbsSlider.on("click", ".thumb-item", function(e) {
        e.preventDefault();
        var number = $(this).index();
        mainSlider.data('owl.carousel').to(number, 300, true);
        $('.thumb-item').not(this).removeClass('active');
        $(this).addClass('active');
      });
    }
  }

  if($('.js-feat-icon-slider').length) {
    $('.js-feat-icon-slider').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: false,
      arrows: true,
      mobileFirst: true,
      responsive: [
        {
          // breakpoint from 750 up
          breakpoint: 750,
          settings: "unslick"
        }
      ]
    });
  }

  if($('.js-ingredients-slider').length) {
    $('.js-ingredients-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      adaptiveHeight: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 500,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
            arrows: true
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false,
            arrows: true
          }
        }
      ]
    });
  }

  if ($(".js-ingredients-slider-alt").length) {
    $(".js-ingredients-slider-alt").slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
            arrows: true,
          },
        },
        {
          breakpoint: 500,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: true,
            appendDots: ".product-ingredients .slider-nav-alt",
            nextArrow: ".product-ingredients .slick-next-mob",
            prevArrow: ".product-ingredients .slick-prev-mob",
            adaptiveHeight: true,
          },
        },
      ],
    });
  }

  // Subscription promo
  if ($(".js-subpromo-slider").length) {
    $(".js-subpromo-slider").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      appendDots: ".subscription-promo .slider-nav-alt",
      nextArrow: ".subscription-promo .slick-next-mob",
      prevArrow: ".subscription-promo .slick-prev-mob",
      adaptiveHeight: true,
      mobileFirst: true,
      responsive: [
        {
          // breakpoint from 750 up
          breakpoint: 750,
          settings: "unslick",
        },
      ],
    });
  }

  if($('.js-story-slider').length) {
    $('.js-story-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      mobileFirst: true,
      responsive: [
        {
          // breakpoint from 989 up
          breakpoint: 989,
          settings: "unslick"
        }
      ]
    });
  }

  if($('.js-clinical-slider').length) {
    $('.js-clinical-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      mobileFirst: true,
      fade: true,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 750,
          settings: "unslick"
        }
      ]
    });
  }

  // Real customers section
  if ($(".js-results-slider").length) {
    $(".js-results-slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      appendDots: ".product-before-after-results .slider-nav-alt",
      nextArrow: ".product-before-after-results .slick-next-mob",
      prevArrow: ".product-before-after-results .slick-prev-mob",
      adaptiveHeight: true,
      swipeToSlide: false,
      swipe: false,
      touchMove: false,
      mobileFirst: true,
      responsive: [
        {
          // breakpoint from 750 up
          breakpoint: 750,
          settings: "unslick",
        },
      ],
    });
  }

});

$(window).on('load', function () {
  const $window = $(window),
	$body = $('body'),
  $section = $('.shopify-section');

  function updateSectionColorOnScroll() {
    var scroll = $window.scrollTop() + ($window.height() / 2);

    $section.each(function () {
      var $this = $(this);
      if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {
        $body.css('background', $(this).find('[data-background-color]').data('background-color'));
      }
    });
  }
  updateSectionColorOnScroll();


  /* Product shop sticky bar on scroll */
  const $stickyShopBar = $('.js-sticky-shop-bar');
  if($stickyShopBar.length) {
    var stickyShopBarTopH = $stickyShopBar.offset().top + $stickyShopBar.outerHeight();
  }

  $(window).on('scroll', function() {
    let windowTopH = $window.scrollTop() + $window.height();

    if(windowTopH > stickyShopBarTopH) {
      $stickyShopBar.addClass('sticky');
    }
    else {
      $stickyShopBar.removeClass('sticky');
    }

    updateSectionColorOnScroll();
  });



  // Increase, decrease quantity
  if($('.js-quantity-btn').length) {
    $('.js-quantity-btn').on('click', function() {
      var $button = $(this);
      var $input = $button.closest('.quantity-spinner-wrap').find(".js-quantity-input");
      $input.val((i, v) => Math.max(1, +v + 1 * $button.data('multi')));
      $input.trigger('change');
    });
  }


  /* If add to cart sticky bar from the app (#satcb_bar) is present,
    update all current value of quantity input when there is a change in the main quantity input field
  */
  if($('[name=quantity]').length) {
    $('.js-quantity__input').on('change', function() {
      /* satcb_quantity is injected by the app. Need to update its quantity value field whenever main quantity field is updated */
      if($('#satcb_quantity').length) {
        $('#satcb_quantity[name=quantity]').val($(this).val());
      }

      // BOGO: Buy X, Get X || quantity x 2
      if($('[data-bogo-quantity]').length) {
        var sectionId = $(this).attr('data-section');
        var qtyFactor = $('.Quantity-'+sectionId+'[data-bogo-quantity]').attr('data-add');
        var bogoQty = $(this).val() * qtyFactor;
        $('.Quantity-'+sectionId+'[data-bogo-quantity]').not($(this)).val(bogoQty);
      }
    });

    $('.js-quantity-input').on('change', function() {
      var sectionId = $(this).data('section');
      $('#Quantity-'+sectionId+'[name=quantity]').not($(this)).val($(this).val());

      // BOGO: Buy X, Get X || quantity x 2
      if($('.Quantity-'+sectionId+'[data-bogo-quantity]').length) {
        var qtyFactor = $('.Quantity-'+sectionId+'[data-bogo-quantity]').attr('data-add');
        let bogo_qty = $(this).val() *  qtyFactor;
        $('.Quantity-'+sectionId+'[data-bogo-quantity]').not($(this)).val(bogo_qty);
      }
    });
  }


  /* Scroll to ID */
  $('a[href*="#"]:not(.cta)').on('click', function(e){
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top - 150,
      },
      500,'linear'
    );
  });

});
